import { createContext, Dispatch, SetStateAction } from 'react';

import {
  AssetDetail,
  CategoryPathItem,
  ElementError,
  InventoryAssetDetailType,
  SearchAssetWithElements,
} from '@atom/types/inventory';

export enum View {
  MAIN = 'MAIN',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum ModalStep {
  ELEMENT = 'ELEMENT',
  DESTINATION = 'DESTINATION',
  CONFIRM = 'CONFIRM',
}

export interface ModalStepType {
  title: string;
  value: ModalStep;
}

interface Context {
  activeStep: ModalStep;
  setActiveStep: Dispatch<SetStateAction<ModalStep>>;
  STEPS_ARRAY: ModalStepType[];
  rootAsset: InventoryAssetDetailType;
  element: AssetDetail;
  destinationAsset: InventoryAssetDetailType | SearchAssetWithElements;
  destinationAssetPath: CategoryPathItem[];
  elementErrors: {
    [elementId: string]: ElementError;
  };
}

export const initialState: Context = {
  activeStep: ModalStep.ELEMENT,
  setActiveStep: () => {},
  STEPS_ARRAY: [],
  rootAsset: null,
  element: null,
  destinationAsset: null,
  destinationAssetPath: [],
  elementErrors: null,
};

const MoveElementModalContext = createContext<Context>(initialState);

export default MoveElementModalContext;
